<h2 mat-dialog-title class="typo-dialog-title">
    <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
    <span class="typo-dialog-title-text">Component Font</span>
    <button mat-icon-button class="typo-dialog-close" (click)="cancel()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="typo-dialog-body">
    <p class="typo-dialog-hint">Overrides cascade over the page and report fonts. Reset an axis to inherit.</p>
    <pv-inheritable-typography
        [parent]="data.parent"
        [value]="working"
        [parentLabel]="data.parentLabel"
        (valueChange)="onChange($event)">
    </pv-inheritable-typography>
</mat-dialog-content>

<mat-dialog-actions align="end" class="typo-dialog-footer">
    <button mat-stroked-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="apply()">
        <mat-icon>check</mat-icon>
        Apply
    </button>
</mat-dialog-actions>
